import React from 'react';
import bolaLaranja from '../assets/icons/bola-laranja.png';
import artigosPessoais from '../assets/icons/icone-artigos-pessoais.png';
import grafica from '../assets/icons/grafica.png';
import lazer from '../assets/icons/lazer.png';
import camisas from '../assets/icons/icone-camisas-e-uniformes.png';
import diversos from '../assets/icons/icone-diversos.png';
import chaveiros from '../assets/icons/icone-chaveiros.png';
import escrita from '../assets/icons/icone-escrita.png';
import cadernos from '../assets/icons/icone-cadernos-e-afins.png';
import infantil from '../assets/icons/icone-infantil.png';
import eletronicos from '../assets/icons/icone-eletronicos.png';
import escritorio from '../assets/icons/icone-escritorio.png';
import bolsas from '../assets/icons/icone-bolsas.png';
import casa from '../assets/icons/icone-casa-e-afins.png';
import copos from '../assets/icons/icone-copos-e-afins.png';
import esporte from '../assets/icons/icone-esporte-e-lazer.png';
import pdv from '../assets/icons/icone-pdf.png';

import outros from '../assets/icons/outros.png';


export default (name) => {
    const Icons = {
        'bola-laranja.png' : bolaLaranja,
        'icone-artigos-pessoais.png': artigosPessoais,
        'artigos-pessoais.png': artigosPessoais,
        'Artigos Pessoais': artigosPessoais,
        'Gráfica': grafica,
        'Grafica': grafica,
        'Lazer': lazer,
        'Lazer e Verão': lazer,
        'Lazer e Verao': lazer,
        'Camisas e Uniformes': camisas,
        'Camisas': camisas,
        'Uniformes': camisas,
        'Diversos': diversos,
        'Chaveiros': chaveiros,
        'Chaveiro': chaveiros,
        'Escrita': escrita,
        'Cadernos e Afins': cadernos,
        'Cadernos': cadernos,
        'Infantil': infantil,
        'Eletrônicos': eletronicos,
        'Eletronicos': eletronicos,
        'Escritório': escritorio,
        'Escritorio': escritorio,
        'Bolsas': bolsas,
        'Casa e Afins': casa,
        'Casas e Afins': casa,
        'Casa': casa,
        'Copo e Cia': copos,
        'Copos e afins': copos,
        'Copos e Afins': copos,
        'Copos': copos,
        'Copo': copos,
        'Esporte e Lazer': esporte,
        'Esporte': esporte,
        'pdv': pdv,
        'PDV': pdv,
        default: outros,
    }

    return Icons[name] || Icons.default;
}
